import { Modal,Button } from 'antd';
import React from 'react';
import styles from './index.module.css'
const NewModal = ({ children, customFooter = { cancel: true, save: true },cancelText, okText,...props }) => {

    return (
        <Modal
            open={true}
            footer={null}
            maskClosable={false}
            {...props}
            className={[styles.NewModal, !customFooter && styles.NewModal_padding, props?.className].join(' ')}
        >
            {children}
            {!props?.footer && customFooter && <div className={styles.footerBtn}>
                {customFooter?.cancel && <Button type="link" size="large" onClick={()=>props?.onCancel('Cancel')}>
                    {cancelText || 'Cancel'}
                </Button>}
                {customFooter?.save && <Button type="primary" size="large" onClick={()=>props?.onOk('Ok')}>
                    {okText || 'Save'}
                </Button>}
            </div>}
        </Modal>
    );
}
export default NewModal;